import script from "./DoughnutOccupation.vue?vue&type=script&lang=js"
export * from "./DoughnutOccupation.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__